import type {
    VideoFilesResponse, VideoFilesFilter, ListVideoDetails,
    ListVideoFramesResponse
} from "../types"
import { instance } from "./api"
import { useAuthStore } from '../stores/t-auth';

async function getVideos(filters: VideoFilesFilter) {
    const auth = useAuthStore();
    let filtros = '?';
    const params = [
        filters.start_date ? `start_date=${filters.start_date}` : '',
        filters.end_date ? `end_date=${filters.end_date}` : '',
        filters.data ? `data=${filters.data}` : '',
        filters.tipo ? `tipo=${filters.tipo}` : '',
        filters.inicio_objetivo ? `inicio_objetivo=${filters.inicio_objetivo}` : '',
        filters.final_objetivo ? `final_objetivo=${filters.final_objetivo}` : '',
        filters.lat_zona ? `lat_zona=${filters.lat_zona}` : '',
        filters.lon_zona ? `lon_zona=${filters.lon_zona}` : '',
        filters.rad_zona ? `rad_zona=${filters.rad_zona}` : '',
        filters.predio_name ? `predio_name=${filters.predio_name}` : '',
        filters.predio_rad ? `predio_rad=${filters.predio_rad}` : ''
    ].filter(param => param).join('&');

    filtros += params;
    console.log("QueryString" + filtros);

    return await instance.get<VideoFilesResponse>("/videos/files" + filtros, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}

async function listVideoDetails(id_file: number) {
    const auth = useAuthStore();

    return await instance.get<ListVideoDetails>("/videos/details/" + id_file, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}

async function listVideoFrames(lat: number, lon: number) {
    const auth = useAuthStore();
    const queryString = `?lat=${lat}&lon=${lon}`;

    return await instance.get<ListVideoFramesResponse>(`/videos/frames${queryString}`, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}
export default {
    getVideos,
    listVideoDetails,
    listVideoFrames
};